import React, { useContext, useEffect, useState } from 'react';
import { Card, Button, Tabs, Tab, Pagination } from 'react-bootstrap';
import { Context } from '..';
import { observer } from 'mobx-react-lite';
import Calendar from '../components/Calendar';
import { useNavigate } from 'react-router-dom';
import { CITY_NEWS_ROUTE, PHOTO_GALLERY_ROUTE } from '../utils/consts';
import { Spinner } from 'react-bootstrap';
import {
    fetchCityNews,
    fetchCommitteeMeetings,
    fetchMayorOnline,
    fetchOnlineMeetings,
    fetchOther,
    fetchPhotoGallery,
} from '../http/NewsAPI';
import city_news_img from '../assets/city_news.png';

const CityNewsList = observer(() => {
    const { cityNews } = useContext(Context);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const cityNewsPages = [];
    const committeeMeetingsPages = [];
    const photoGalleryPages = [];
    const onlineMeetingsPages = [];
    const mayorOnlinePages = [];
    const otherPages = [];

    useEffect(() => {
        Promise.all([
            fetchCityNews(1, 10),
            fetchCommitteeMeetings(1, 10),
            fetchPhotoGallery(1, 10),
            fetchOnlineMeetings(1, 10),
            fetchMayorOnline(1, 10),
            fetchOther(1, 10),
        ])
            .then(
                ([
                    cityNewsData,
                    committeeMeetingsData,
                    photoGalleryData,
                    onlineMeetingsData,
                    mayorOnlineData,
                    otherData,
                ]) => {
                    cityNews.setCityNews(cityNewsData.rows);
                    cityNews.setCityNewsTotalCount(cityNewsData.count);

                    cityNews.setCommitteeMeetings(committeeMeetingsData.rows);
                    cityNews.setCommitteeMeetingsTotalCount(committeeMeetingsData.count);

                    cityNews.setPhotoGallery(photoGalleryData.rows);
                    cityNews.setPhotoGalleryTotalCount(photoGalleryData.count);

                    cityNews.setOnlineMeetings(onlineMeetingsData.rows);
                    cityNews.setOnlineMeetingsTotalCount(onlineMeetingsData.count);

                    cityNews.setMayorOnline(mayorOnlineData.rows);
                    cityNews.setMayorOnlineTotalCount(mayorOnlineData.count);

                    cityNews.setOther(otherData.rows);
                    cityNews.setOtherTotalCount(otherData.count);
                }
            )
            .finally(() => setLoading(false));
    }, [cityNews]);

    useEffect(() => {
        Promise.all([
            fetchCityNews(cityNews.cityNewsPage, cityNews.cityNewsLimit),
            fetchCommitteeMeetings(cityNews.committeeMeetingsPage, cityNews.committeeMeetingsLimit),
            fetchPhotoGallery(cityNews.photoGalleryPage, cityNews.photoGalleryLimit),
            fetchOnlineMeetings(cityNews.onlineMeetingsPage, cityNews.onlineMeetingsLimit),
            fetchMayorOnline(cityNews.mayorOnlinePage, cityNews.mayorOnlineLimit),
            fetchOther(cityNews.otherPage, cityNews.otherLimit),
        ]).then(
            ([
                cityNewsData,
                committeeMeetingsData,
                photoGalleryData,
                onlineMeetingsData,
                mayorOnlineData,
                otherData,
            ]) => {
                cityNews.setCityNews(cityNewsData.rows);
                cityNews.setCityNewsTotalCount(cityNewsData.count);

                cityNews.setCommitteeMeetings(committeeMeetingsData.rows);
                cityNews.setCommitteeMeetingsTotalCount(committeeMeetingsData.count);

                cityNews.setPhotoGallery(photoGalleryData.rows);
                cityNews.setPhotoGalleryTotalCount(photoGalleryData.count);

                cityNews.setOnlineMeetings(onlineMeetingsData.rows);
                cityNews.setOnlineMeetingsTotalCount(onlineMeetingsData.count);

                cityNews.setMayorOnline(mayorOnlineData.rows);
                cityNews.setMayorOnlineTotalCount(mayorOnlineData.count);

                cityNews.setOther(otherData.rows);
                cityNews.setOtherTotalCount(otherData.count);
            }
        );
    }, [
        cityNews.cityNewsPage,
        cityNews.committeeMeetingsPage,
        cityNews.photoGalleryPage,
        cityNews.onlineMeetingsPage,
        cityNews.mayorOnlinePage,
        cityNews.otherPage,
    ]);

    const cityNewsPageCount = Math.ceil(cityNews.cityNewsTotalCount / cityNews.cityNewsLimit);
    const committeeMeetingsPageCount = Math.ceil(
        cityNews.committeeMeetingsTotalCount / cityNews.committeeMeetingsLimit
    );
    const photoGalleryPageCount = Math.ceil(cityNews.photoGalleryTotalCount / cityNews.photoGalleryLimit);
    const onlineMeetingsPageCount = Math.ceil(cityNews.onlineMeetingsTotalCount / cityNews.onlineMeetingsLimit);
    const mayorOnlinePageCount = Math.ceil(cityNews.mayorOnlineTotalCount / cityNews.mayorOnlineLimit);
    const otherPageCount = Math.ceil(cityNews.otherTotalCount / cityNews.otherLimit);

    for (let i = 1; i <= cityNewsPageCount; i++) {
        cityNewsPages.push(i);
    }
    for (let i = 1; i <= committeeMeetingsPageCount; i++) {
        committeeMeetingsPages.push(i);
    }
    for (let i = 1; i <= photoGalleryPageCount; i++) {
        photoGalleryPages.push(i);
    }
    for (let i = 1; i <= onlineMeetingsPageCount; i++) {
        onlineMeetingsPages.push(i);
    }
    for (let i = 1; i <= mayorOnlinePageCount; i++) {
        mayorOnlinePages.push(i);
    }
    for (let i = 1; i <= otherPageCount; i++) {
        otherPages.push(i);
    }

    if (loading) {
        return (
            <div className="d-flex align-items-center justify-content-center py-5">
                <Spinner animation={'grow'} />
            </div>
        );
    }
    return (
        <div className="d-flex flex-xl-row flex-column justify-content-center px-xl-4 px-2">
            <div className="py-4 px-5 border-bottom col-md-9">
                <div className="block-title pb-4">
                    <span>Noutațile orașului</span>
                </div>
                <Tabs defaultActiveKey="news" id="fill-tab-example" className="mb-3 text-primary" fill>
                    <Tab eventKey="news" title="Noutăți" className="text-primary fw-bold">
                        <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
                            {cityNews.cityNews &&
                                cityNews.cityNews.map((item, idx) => {
                                    return (
                                        <Card
                                            key={idx}
                                            style={{ width: '22rem' }}
                                            className="my-3"
                                            onClick={() => navigate(CITY_NEWS_ROUTE + '/' + item.id)}
                                        >
                                            {/* <Card.Img
													variant='top'
													src='https://picsum.photos/400/250'
												/> */}
                                            <div
                                                className="h-100 rounded"
                                                style={{
                                                    minHeight: '20vh',
                                                    background: `url(${
                                                        item.city_news_files.length > 0
                                                            ? process.env.REACT_APP_API_URL +
                                                              item.city_news_files[0].img
                                                            : city_news_img
                                                    })  center center/cover no-repeat`,
                                                }}
                                            ></div>
                                            <Card.Body>
                                                <Card.Title className="mb-3 d-flex align-items-center justify-content-between">
                                                    <span
                                                        className="border border-primary rounded text-primary p-2"
                                                        style={{ fontSize: '1rem' }}
                                                    >
                                                        {item.date}
                                                    </span>
                                                    {item.isNew ? (
                                                        <span
                                                            className="border bg-primary rounded text-white p-2"
                                                            style={{ fontSize: '1rem' }}
                                                        >
                                                            NEW
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}
                                                </Card.Title>
                                                <Card.Text
                                                    onClick={() => navigate(CITY_NEWS_ROUTE + '/' + item.id)}
                                                    className="truncate"
                                                >
                                                    {item.title}
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    );
                                })}
                        </div>
                        <Pagination className="d-flex justify-content-center align-items-center mt-5">
                            {cityNewsPages.map((page) => (
                                <Pagination.Item
                                    key={'cN-' + page}
                                    active={cityNews.cityNewsPage === page}
                                    onClick={() => cityNews.setCityNewsPage(page)}
                                >
                                    {page}
                                </Pagination.Item>
                            ))}
                        </Pagination>
                    </Tab>
                    <Tab eventKey="commission-meetings" title="Ședințe comisii" className="text-primary fw-bold">
                        <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
                            {cityNews.committeeMeetings &&
                                cityNews.committeeMeetings.map((item, idx) => {
                                    return (
                                        <Card key={idx} style={{ width: '22rem' }} className="my-3">
                                            <div
                                                className="h-100 rounded"
                                                style={{
                                                    minHeight: '20vh',
                                                    background: `url(${
                                                        process.env.REACT_APP_API_URL + item.img
                                                    })  center center/cover no-repeat`,
                                                }}
                                            ></div>
                                            <Card.Body>
                                                <Card.Title className="mb-3 d-flex align-items-center justify-content-between">
                                                    <span
                                                        className="border border-primary rounded text-primary p-2"
                                                        style={{ fontSize: '1rem' }}
                                                    >
                                                        {item.date}
                                                    </span>
                                                    {item.isNew ? (
                                                        <span
                                                            className="border bg-primary rounded text-white p-2"
                                                            style={{ fontSize: '1rem' }}
                                                        >
                                                            NEW
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )}
                                                </Card.Title>
                                                <Card.Text
                                                    onClick={() => navigate(CITY_NEWS_ROUTE + '/' + item.id)}
                                                    className="truncate"
                                                >
                                                    {item.title}
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    );
                                })}
                        </div>
                    </Tab>
                    <Tab eventKey="photos" title="Fotografii" className="text-primary fw-bold">
                        <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
                            {cityNews.photoGallery.map((item, idx) => {
                                return (
                                    <Card
                                        key={idx}
                                        style={{ width: '22rem' }}
                                        className="my-3"
                                        onClick={() => navigate(PHOTO_GALLERY_ROUTE + '/' + item.id)}
                                    >
                                        {/* <Card.Img
													variant='top'
													src={item.photo_gallery_files[0].img}
												/> */}
                                        <div
                                            className="h-100 rounded"
                                            style={{
                                                minHeight: '20vh',
                                                background: `url(${
                                                    item.photo_gallery_files.length > 0
                                                        ? process.env.REACT_APP_API_URL +
                                                          item.photo_gallery_files[0].img
                                                        : city_news_img
                                                })  center center/cover no-repeat`,
                                            }}
                                        ></div>
                                        <Card.Body>
                                            <Card.Title className="mb-3 d-flex align-items-center justify-content-between">
                                                <span
                                                    className="border border-primary rounded text-primary p-2"
                                                    style={{ fontSize: '1rem' }}
                                                >
                                                    {item.date}
                                                </span>
                                                {item.isNew ? (
                                                    <span
                                                        className="border bg-primary rounded text-white p-2"
                                                        style={{ fontSize: '1rem' }}
                                                    >
                                                        NEW
                                                    </span>
                                                ) : (
                                                    ''
                                                )}
                                            </Card.Title>
                                            <Card.Text
                                                onClick={() => navigate(CITY_NEWS_ROUTE + '/' + item.id)}
                                                className="truncate"
                                            >
                                                {item.title}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                );
                            })}
                        </div>
                        <Pagination className="d-flex justify-content-center align-items-center mt-5">
                            {photoGalleryPages.map((page) => (
                                <Pagination.Item
                                    key={'pG-' + page}
                                    active={cityNews.photoGalleryPage === page}
                                    onClick={() => cityNews.setPhotoGalleryPage(page)}
                                >
                                    {page}
                                </Pagination.Item>
                            ))}
                        </Pagination>
                    </Tab>
                    <Tab eventKey="online-meetings" title="Ședințe online" className="text-primary fw-bold">
                        <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
                            {cityNews.onlineMeetings.map((item, idx) => {
                                return (
                                    <Card key={idx} style={{ width: '22rem', minHeight: 330 }} className="my-3">
                                        {/* <Card.Img variant="top" src={item.video_link} /> */}
                                        <div
                                            className="h-100 rounded"
                                            style={{
                                                minHeight: '20vh',
                                                background: `url(${
                                                    item.link.includes('facebook')
                                                        ? 'https://1000logos.net/wp-content/uploads/2016/11/fb-logo.jpg'
                                                        : 'https://assets.turbologo.com/blog/en/2019/10/19084944/youtube-logo-illustration-958x575.jpg'
                                                })  center center/cover no-repeat`,
                                            }}
                                        ></div>
                                        <Card.Body>
                                            <Card.Title className="mb-3 d-flex align-items-center justify-content-between">
                                                <span
                                                    className="border border-primary rounded text-primary p-2"
                                                    style={{ fontSize: '1rem' }}
                                                >
                                                    {item.date}
                                                </span>
                                                {item.isNew ? (
                                                    <span
                                                        className="border bg-primary rounded text-white p-2"
                                                        style={{ fontSize: '1rem' }}
                                                    >
                                                        NEW
                                                    </span>
                                                ) : (
                                                    ''
                                                )}
                                            </Card.Title>
                                            <Card.Text
                                                onClick={() => navigate(CITY_NEWS_ROUTE + '/' + item.id)}
                                                className="truncate"
                                            >
                                                {item.title}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                );
                            })}
                        </div>
                        <Pagination className="d-flex justify-content-center align-items-center mt-5">
                            {onlineMeetingsPages.map((page) => (
                                <Pagination.Item
                                    key={'oM-' + page}
                                    active={cityNews.onlineMeetingsPage === page}
                                    onClick={() => cityNews.setOnlineMeetingsPage(page)}
                                >
                                    {page}
                                </Pagination.Item>
                            ))}
                        </Pagination>
                    </Tab>
                    <Tab eventKey="mayor-online" title="Primarul Online" className="text-primary fw-bold">
                        <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
                            {cityNews.mayorOnline.map((item, idx) => {
                                return (
                                    <Card key={idx} style={{ width: '22rem', minHeight: 330 }} className="my-3">
                                        {/* <Card.Img variant="top" src={item.video_link} /> */}
                                        <div
                                            className="h-100 rounded"
                                            style={{
                                                minHeight: '20vh',
                                                background: `url(${
                                                    item.link.includes('facebook')
                                                        ? 'https://1000logos.net/wp-content/uploads/2016/11/fb-logo.jpg'
                                                        : 'https://assets.turbologo.com/blog/en/2019/10/19084944/youtube-logo-illustration-958x575.jpg'
                                                })  center center/cover no-repeat`,
                                            }}
                                        ></div>
                                        <Card.Body>
                                            <Card.Title className="mb-3 d-flex align-items-center justify-content-between">
                                                <span
                                                    className="border border-primary rounded text-primary p-2"
                                                    style={{ fontSize: '1rem' }}
                                                >
                                                    {item.date}
                                                </span>
                                                {item.isNew ? (
                                                    <span
                                                        className="border bg-primary rounded text-white p-2"
                                                        style={{ fontSize: '1rem' }}
                                                    >
                                                        NEW
                                                    </span>
                                                ) : (
                                                    ''
                                                )}
                                            </Card.Title>
                                            <Card.Text
                                                onClick={() => navigate(CITY_NEWS_ROUTE + '/' + item.id)}
                                                className="truncate"
                                            >
                                                {item.title}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                );
                            })}
                        </div>
                        <Pagination className="d-flex justify-content-center align-items-center mt-5">
                            {mayorOnlinePages.map((page) => (
                                <Pagination.Item
                                    key={'mO-' + page}
                                    active={cityNews.mayorOnlinePage === page}
                                    onClick={() => cityNews.setMayorOnlinePage(page)}
                                >
                                    {page}
                                </Pagination.Item>
                            ))}
                        </Pagination>
                    </Tab>
                    <Tab eventKey="another" title="Alte" className="text-primary fw-bold">
                        <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
                            {cityNews.other.map((item, idx) => {
                                return (
                                    <Card key={idx} style={{ width: '22rem', minHeight: 330 }} className="my-3">
                                        {/* <Card.Img variant="top" src={item.video_link} /> */}
                                        <div
                                            className="h-100 rounded"
                                            style={{
                                                minHeight: '20vh',
                                                background: `url(${
                                                    item.link.includes('facebook')
                                                        ? 'https://1000logos.net/wp-content/uploads/2016/11/fb-logo.jpg'
                                                        : 'https://assets.turbologo.com/blog/en/2019/10/19084944/youtube-logo-illustration-958x575.jpg'
                                                })  center center/cover no-repeat`,
                                            }}
                                        ></div>
                                        <Card.Body>
                                            <Card.Title className="mb-3 d-flex align-items-center justify-content-between">
                                                <span
                                                    className="border border-primary rounded text-primary p-2"
                                                    style={{ fontSize: '1rem' }}
                                                >
                                                    {item.date}
                                                </span>
                                                {item.isNew ? (
                                                    <span
                                                        className="border bg-primary rounded text-white p-2"
                                                        style={{ fontSize: '1rem' }}
                                                    >
                                                        NEW
                                                    </span>
                                                ) : (
                                                    ''
                                                )}
                                            </Card.Title>
                                            <Card.Text
                                                onClick={() => navigate(CITY_NEWS_ROUTE + '/' + item.id)}
                                                className="truncate"
                                            >
                                                {item.title}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>
                                );
                            })}
                        </div>
                        <Pagination className="d-flex justify-content-center align-items-center mt-5">
                            {otherPages.map((page) => (
                                <Pagination.Item
                                    key={'o-' + page}
                                    active={cityNews.otherPage === page}
                                    onClick={() => cityNews.setOtherPage(page)}
                                >
                                    {page}
                                </Pagination.Item>
                            ))}
                        </Pagination>
                    </Tab>
                </Tabs>
            </div>
            <Calendar />
        </div>
    );
});

export default CityNewsList;
